module.exports = __webpack_public_path__ + "img/Activities-Sources.b9ee8b5f.svg";